import { createContext } from 'react'

interface ImpersonationContextType {
  impersonatedUserEmail: string | null
  impersonateUser: (_email: string) => Promise<void>
  endImpersonation: () => void
  impersonatedUserId: string | null
  impersonatedUserToken: string | null
  imepersonatedUserOffice: string | null
}

export const ImpersonationContext = createContext<ImpersonationContextType>({
  impersonatedUserEmail: null,
  impersonatedUserId: null,
  impersonatedUserToken: null,
  imepersonatedUserOffice: null,
  //default functionality
  impersonateUser: async () => {
    console.log('ImpersonationContext -> impersonateUser default functionality')
  },
  //default functionality
  endImpersonation: () => {
    console.log(
      'ImpersonationContext -> endImpersonation default functionality',
    )
  },
})
